import React from 'react';
import { Box } from '@mui/material';
import { CustomSwitch } from '@/components/common';

/**
 * 사용자 활성화 여부 셀 컴포넌트
 * 
 * 사용자의 활성화 상태를 토글할 수 있는 스위치를 표시합니다.
 * 
 */
const ProblemStatusCell = ({ row, onStatusChange }) => {
  const currentStatus = row.isApproval === true ? true : false;
  
  return (
    <Box
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      sx={{ display: 'flex', alignItems: 'center', height: '100%' }}
    >
      <CustomSwitch
        value={currentStatus === true}
        onChangeToggle={(e) => onStatusChange(row.problemId, currentStatus)}
        message={`정말로 해당 문제를 ${currentStatus ? '반려' : '승인'} 처리하시겠습니까? ${!currentStatus ? "승인 처리는 가급적 풀어보기 진행 후, 승인 처리하는 것을 권장합니다." : ""}`}
      />
    </Box>
  );
};

export default ProblemStatusCell;
